export default {
  namespaced: true,
  state: {
    products: [],
  },
  getters: {
    getListProducts: state => ({ sort }) => {
      switch (sort) {
        case "asc":
          return state.products.sort((p1, p2) => p1.sortPrice - p2.sortPrice);
        case "desc":
          return state.products.sort((p1, p2) => p2.sortPrice - p1.sortPrice);
        default:
          return state.products;
      }
    },
  },
  actions: {
    setListProducts: ({ commit }, products) => {
      const productsWithSortPrice = products.map(product => ({
        ...product,
        sortPrice: Math.min(...product.variants.map(variant => variant.price)),
      }));
      commit("setListProducts", productsWithSortPrice);
    },
    setSortPrice: ({ commit }, data) => {
      commit("setSortPrice", data);
    },
  },
  mutations: {
    setListProducts: (state, products) => {
      state.products = products;
    },
    setSortPrice: (state, { product, price }) => {
      state.products.find(stateProduct => product == stateProduct).sortPrice = price;
    },
  },
};
